/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-09-13 14:53:45
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-25 10:34:15
 */
import { Button, Checkbox, Col, Collapse, Divider, Popover, Row } from 'antd'
import React, { ReactElement, useState } from 'react'
import { Label } from '../../../compnents/widgets/Label'
import { HistoryContent } from './historyContent'
import { HistoryTitle } from './historyTitle'
import styles from './TcmCases.module.css'

type action = 'check' | 'active' | 'again'
interface HistoryPanelProps {
  historyList: any
  historyData: any
  tag?: any
  onChange: (v: string) => void
  onCopy: (copyRecipe: boolean, srcTreatmentId: string) => void
  lookMoreHistoryList?: (num?: any) => void
  CollapseActivekey: string
  changeAction: (action: action, v?: any) => void
  seeOtherDoctor: boolean
  reuseTreatmentId?: string
  toothRegistrationId?: string
}

export const HistoryPanel = ({
  historyList,
  historyData,
  tag,
  onChange,
  onCopy,
  lookMoreHistoryList,
  CollapseActivekey,
  changeAction,
  seeOtherDoctor,
  reuseTreatmentId,
  toothRegistrationId, // 口腔专业版
}: HistoryPanelProps): ReactElement => {
  const [text, setText] = useState<any>()

  const [fzblLoading, setfzblLoading] = useState(false)

  const historyItemTwo = [
    {
      name: '主诉：',
      value: 'chiefComplaint',
      flag: 1,
    },
    {
      name: '现病史：',
      value: 'historyOfPresentIllness',
      flag: 4,
    },
    {
      name: '既往史：',
      value: 'pastMedicalHistory',
      flag: 4,
    },
    {
      name: '过敏史：',
      value: 'allergen',
      flag: 4,
    },
    {
      name: '舌象：',
      value: 'tonguePicture',
      flag: 1,
    },
    {
      name: '脉象：',
      value: 'pulseCondition',
      flag: 1,
    },
    {
      name: '疾病名称：',
      value: tag == 'tooth' ? 'diseaseList' : 'disease',
      flag: 2,
    },
    {
      name: '个人史：',
      value: 'personalHistory',
      flag: 4,
    },
    {
      name: '家族史：',
      value: 'familyHistory',
      flag: 4,
    },
    {
      name: '疫苗接种史：',
      value: 'vaccineHistory',
      flag: 3,
    },
    {
      name: '月经史：',
      value: 'menstrualHistory',
      flag: 4,
    },
    {
      name: '婚育史：',
      value: 'maritalHistory',
      flag: 4,
    },
    {
      name: '体格检查：',
      value: 'tgjc',
      flag: 2,
    },
    {
      name: '口腔检查：',
      value: 'stomatologyToothList',
      flag: 2,
    },

    {
      name: '辅助检查：',
      value: tag == 'tooth' ? 'inspectionToothList' : 'inspectionCheck',
      flag: 2,
    },
    {
      name: '治疗计划：',
      value: 'treatmentToothList',
      flag: 2,
    },
    {
      name: '处置：',
      value: 'disposeToothList',
      flag: 1,
    },
    {
      name: '治疗意见：',
      value: 'treatmentConclusion',
      flag: 2,
    },
  ]

  const { Panel } = Collapse

  const message = seeOtherDoctor
    ? '您没有接诊过该患者'
    : '该患者在本机构没有历史就诊记录'

  return (
    <>
      {/*{!toothRegistrationId && (*/}
      {/*  <>*/}
      {/*    <Label label='就诊历史' style={{ marginLeft: 20 }} />*/}
      {/*    <Divider />*/}
      {/*  </>*/}
      {/*)}*/}
      <Col
        style={{
          padding: 10,
        }}
      >
        <Checkbox
          checked={seeOtherDoctor}
          onChange={(e) => {
            changeAction('check', e.target.checked)
            const check: any = e.target.checked
            localStorage.setItem('historyPanelCheck', check)
          }}
        >
          不看其他医生
        </Checkbox>
      </Col>
      <Col className={styles.historyContainer}>
        {historyList.length ? (
          <Collapse
            key={historyList[0]?.id}
            expandIconPosition='right'
            defaultActiveKey={historyList[0]?.id}
            accordion
            activeKey={CollapseActivekey}
            onChange={(v) => {
              changeAction('active', v as string)
              if (v && !historyData[v as string]) {
                onChange(v as string)
              }
            }}
          >
            {historyList.map((t: any) => (
              <Panel
                header={
                  <HistoryTitle t={t} CollapseActivekey={CollapseActivekey} />
                }
                key={t.id}
                style={{
                  backgroundColor: CollapseActivekey == t.id ? '#FAFAFA' : '',
                }}
              >
                <Row
                  justify='space-between'
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <Button
                    size='small'
                    // type='primary'
                    onClick={() => {
                      onCopy(true, t.id)
                    }}
                  >
                    复制病历及处方
                  </Button>
                  <Button
                    loading={fzblLoading}
                    // type='primary'
                    size='small'
                    onClick={() => {
                      setfzblLoading(true)
                      onCopy(false, t.id)
                      setTimeout(() => {
                        setfzblLoading(false)
                      }, 2000)
                    }}
                  >
                    复制病历
                  </Button>
                  <Button
                    size='small'
                    type={reuseTreatmentId == t.id ? 'primary' : 'default'}
                    onClick={() => {
                      changeAction(
                        'again',
                        reuseTreatmentId == t.id ? '' : t.id
                      )
                    }}
                  >
                    复诊
                  </Button>
                </Row>
                {historyItemTwo.map((v) => {
                  return (tag != 'tooth' && t[v.value]) || (tag === 'tooth' && t[v.value]?.[0]?.indexOf("<span>#</span>")<0) ? (
                    <div className={styles.historyItem}>
                      <div
                        className={
                          v.flag == 1
                            ? styles.historyNoWarp
                            : v.flag == 3
                            ? styles.historyWarpWidth
                            : v.flag == 4
                            ? styles.historyWarpWidthThreeText
                            : styles.historyWarp
                        }
                      >
                        {v.name}
                      </div>
                      <div className={styles.rightContent}>
                        {tag === 'tooth' && v?.value == 'diseaseList' ? (
                          t?.diseaseList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'stomatologyToothList' ? (
                          t?.stomatologyToothList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'inspectionToothList' ? (
                          t?.inspectionToothList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'treatmentToothList' ? (
                          t?.treatmentToothList?.map((item: any) => {
                            return (
                              <div
                                dangerouslySetInnerHTML={{ __html: item }}
                                key={item}
                                className={styles.rightContentText}
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'disposeToothList' ? (
                          t?.disposeToothList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : (
                          <div>{t[v.value].split('#%#').join('，')}</div>
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )
                })}
                {historyData[t.id] &&
                  historyData[t.id].map((re: any, i: number) => (
                    <HistoryContent v={re} key={i} />
                  ))}
                <Row
                  justify='space-between'
                  style={{
                    marginTop: 5,
                    color: '#666',
                  }}
                >
                  <span>{t.createTime}</span>
                  <span>
                    金额:￥
                    {historyData[t.id] &&
                      historyData[t.id]
                        .map((v: any) => v.amount)
                        ?.reduce((total: number, currentValue: number) => {
                          return total + currentValue
                        }, 0)
                        ?.toFixed(2)}
                  </span>
                </Row>
              </Panel>
            ))}
          </Collapse>
        ) : (
          <div
            className={styles.historyMessage}
            style={{
              fontStyle: 'oblique',
              color: '#999',
            }}
          >
            {message}
          </div>
        )}
      </Col>
      <Row
        style={{
          fontStyle: 'oblique',
          color: '#999',
          padding: '0 15px',
          marginTop: 3,
        }}
        justify='end'
      >
        <div
          style={{
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
           
          }}
        >
          <Popover
            content={
              <p>
                {text
                  ? text
                  : '默认展示近1年数据，如需查看近5年数据，请点击查看更多数据'}
              </p>
            }
            placement='bottom'
          >
            <span>
              {text
                ? text
                : '默认展示近1年数据，如需查看近5年数据，请点击'}
            </span>
          </Popover>
          {text ? (
            ''
          ) : (
            <a
              style={{ paddingLeft: '6px' }}
              onClick={() => {
                lookMoreHistoryList && lookMoreHistoryList(5)
                setText('仅展示近5年数据，如需更多请联系服务人员')
              }}
            >
              查看更多数据
            </a>
          )}
        </div>
      </Row>
    </>
  )
}
